import {PROJECTS_CRUD_MODAL, PROJECTS_CRUD_RESET, PROJECTS_CRUD_SET_LIST} from "../lib/types";

export const createMockProjects = () => {
  let projects = []
  for (let i = 0; i < 30; i++) {
    projects.push({
      projectName: 'Project-' + i,
      engineer: 'User-' + i,
      city: 'City-' + i,
      state: 'State-' + i,
      created: 'Created date-' + i,
      status: 'Status-' + i
    })
  }
  return projects
}

const initialState = {
  showProjectsCrudModal: false,
  //TODO:Set Data from API Call
  projects:[]
};
export let ProjectsCrudReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECTS_CRUD_MODAL:
      return {
        ...state,
        showProjectsCrudModal: action.payload
      };
    case PROJECTS_CRUD_SET_LIST:
      return {
        ...state,
        projects: action.payload
      }
    case PROJECTS_CRUD_RESET:
      return {
        ...state,
        projects: initialState.projects
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/projects-crud-reducer.js